import React from "react";
import Avatar from "../utils/Avatar";
import {
  Box,
  Typography,
  Grid,
  Paper,
  Divider,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Decrypt from "../utils/Decrypt";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";

const InfoWindowContent = ({ data, setSelectedLocation }) => {
  const role = localStorage.getItem("role");
  const {
    ownerName,
    vendorBussinessName,
    city,
    state,
    ownerPrimaryContactNo,
    stars,
    creditLimit,
  } = data;
  let displayName = ownerName?.slice(0, 10);

  if (role === "-1") {
    const name = Decrypt(ownerName);
    displayName = name?.charAt(0).toUpperCase() + name?.slice(1);
  }

  const maxStars = 5;

  return (
    <Paper
      elevation={1}
      sx={{
        width: 300, // Take full width of the InfoWindow
        borderRadius: 0, // Remove rounded corners
        margin: 0, // Remove any margin
        padding: 0, // Remove any padding
        overflow: "hidden", // Prevent content overflow
        border: "none", // Remove border
      }}
    >
      <Box
        sx={{
          backgroundColor: "var(--googleMap-card-color)",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "4px", // Adjust padding as necessary
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Avatar
            name={displayName
              ?.split(" ")
              .map((ele) => ele.charAt(0).toUpperCase())
              .join("")}
          />
          <Box>
            <Typography variant="subtitle3" color="text.primary">
              {vendorBussinessName}
            </Typography>
            <div variant="caption" color="text.secondary">
              <LocationOnOutlinedIcon
                sx={{ fontSize: 12, marginBottom: 0.3 }}
              />
              {city}, {state}
            </div>
          </Box>
        </Box>
        <Box>
          <Box sx={{ display: "" }}>
            <Typography
              variant="caption"
              sx={{ textAlign: "end", display: "block" }}
            >
              {" "}
              <CloseIcon
                fontSize="small"
                sx={{ cursor: "pointer" }}
                onClick={() => setSelectedLocation(null)}
              />
            </Typography>
            {Array.from({ length: maxStars }).map((_, index) => (
              <span
                key={index}
                style={{ fontSize: "12px", marginRight: "2px" }}
              >
                {index < stars ? "⭐" : "★"}
              </span>
            ))}
          </Box>
        </Box>
      </Box>

      <Divider />

      <Box sx={{ padding: "8px" }}>
        {" "}
        {/* Adjust padding */}
        <Grid container spacing={1} alignItems="center">
          <Grid item xs={6}>
            <Typography variant="body2" sx={{ color: "var(--heading-color)" }}>
              Owner
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography
              variant="body2"
              textAlign="left"
              sx={{ color: "var(--heading-color)" }}
            >
              {displayName}
            </Typography>
          </Grid>

          <Grid item xs={6}>
            <Typography variant="body2" sx={{ color: "var(--heading-color)" }}>
              Primary Contact
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography
              variant="body2"
              textAlign="left"
              sx={{ color: "var(--heading-color)" }}
            >
              {role == "-1"
                ? Decrypt(ownerPrimaryContactNo)
                : ownerPrimaryContactNo.slice(0, 10)}
            </Typography>
          </Grid>

          <Grid item xs={6}>
            <Typography variant="body2" sx={{ color: "var(--heading-color)" }}>
              Credit Limit
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography
              variant="body2"
              textAlign="left"
              sx={{ color: "var(--heading-color)" }}
            >
              {creditLimit || "N/A"}
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </Paper>
  );
};

export default InfoWindowContent;
